"use strict";

/* eslint-disable global-require */
var processInclude = require('base/util');
var $ = require('jquery');
$(document).ready(function () {
  processInclude(require('./adyen/express/cart/expressPayments'));
});